import api from '../config/api';

/**
 * CTS (depósitos mayo / noviembre). Base URL ya incluye /api (environment.js).
 */
const ctsService = {
  getPeriodos: async (empresaId, anio = new Date().getFullYear()) => {
    const response = await api.get('/cts/periodos', {
      params: { empresa_id: empresaId, anio },
    });
    return response.data;
  },

  calcular: async (empresaId, periodo, anio) => {
    const periodoApi = periodo === 'Mayo' ? 'mayo' : 'noviembre';
    const response = await api.get('/cts/calcular', {
      params: {
        empresa_id: empresaId,
        periodo: periodoApi,
        anio: Number(anio),
      },
    });
    return response.data;
  },

  list: async (empresaId, anio = null, estado = null) => {
    const params = { empresa_id: empresaId };
    if (anio != null) params.anio = anio;
    if (estado != null) params.estado = estado;
    const response = await api.get('/cts', { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/cts/${id}`);
    return response.data;
  },

  create: async (empresaId, periodo, anio) => {
    const response = await api.post('/cts', {
      empresa_id: empresaId,
      periodo: periodo === 'Mayo' ? 'mayo' : 'noviembre',
      anio: Number(anio),
    });
    return response.data;
  },

  cerrar: async (id, entraraEnPlanilla) => {
    const response = await api.put(`/cts/${id}/cerrar`, {
      entrara_en_planilla: entraraEnPlanilla === true,
    });
    return response.data;
  },

  abrir: async (id) => {
    const response = await api.put(`/cts/${id}/abrir`);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/cts/${id}`);
    return response.data;
  },

  /**
   * Actualizar sueldos_mensuales (conceptos incluir) y recalcular fila + total CTS.
   * PUT /api/cts/{ctsId}/detalles/{empleadoId}
   */
  updateDetalle: async (ctsId, empleadoId, payload) => {
    const response = await api.put(`/cts/${ctsId}/detalles/${empleadoId}`, payload);
    return response.data;
  },
};

export default ctsService;
